import type { TDeepObject } from '../models';

/**
 * Получить значение по пропсам аргумента шаблона
 * @param param параметр хранящий значение (представляется в виде бесконечно-вложенного объекта)
 * @param props пропсы аргумента шаблона
 * @returns значение из `param` на основе ключей из `props`
 */
export const getValueByArgumentProps = (param: unknown, props: string[]) => {
    const value = props.reduce((acc, prop) => acc[prop], param as TDeepObject);

    return typeof value === 'string' ? value : JSON.stringify(value);
};
